module.exports = __webpack_public_path__ + "img/Mosul_title_shot.c970f8a6.jpg";